import { useState, useEffect } from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const NextofKinPanel = ({
  id_R,
  closeNextOfKinPanel,
  isNextOfKinPanelOpen,
  relationship,
  setRelationship,
  dateOfBirth,
  setDateOfBirth,
  fullName,
  setFullName,
  location,
  setLocation,
  mobileNumber,
  setMobileNumber,
  handleNextOfKin,
  loading,
}) => {
  const [phoneError, setPhoneError] = useState("");

  const validatePhoneNumber = (number) => {
    if (!number) {
      setPhoneError("");
      return false;
    }

    if (number.startsWith("0") && number.length !== 10) {
      setPhoneError("Phone number starting with 0 must be 10 digits");
      return false;
    }

    if (number.startsWith("254") && number.length !== 12) {
      setPhoneError("Phone number starting with 254 must be 12 digits");
      return false;
    }

    if (!number.startsWith("0") && !number.startsWith("254")) {
      setPhoneError("Phone number must start with 0 or 254");
      return false;
    }

    setPhoneError("");
    return true;
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.startsWith("254")) {
      value = value.slice(0, 12);
    } else if (value.startsWith("0")) {
      value = value.slice(0, 10);
    }

    setMobileNumber(value);

    if (value.length > 0) {
      validatePhoneNumber(value);
    } else {
      setPhoneError("");
    }
  };

  const [isInputsFilled, setIsInputsFilled] = useState(false);
  const today = new Date()?.toISOString()?.split("T")[0];

  useEffect(() => {
    const phoneValid = validatePhoneNumber(mobileNumber);

    const areInputsFilled =
      fullName &&
      dateOfBirth &&
      relationship &&
      location &&
      mobileNumber &&
      phoneValid;

    setIsInputsFilled(areInputsFilled);
  }, [dateOfBirth, relationship, fullName, location, mobileNumber]);

  return (
    <SlidePanel isOpen={isNextOfKinPanelOpen} onClose={closeNextOfKinPanel}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close Button */}
        <div
          onClick={closeNextOfKinPanel}
          className="absolute top-0 right-0 cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] flex items-center justify-center z-10"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex flex-col h-full">
          <div className="mt-5 px-5">
            <p className="text-[#000] text-xl font-bold">
              New Member - Next of Kin
            </p>
            <div className="text-[#000] text-[15px] font-normal">
              <p>
                Enter Member’s next of kin details details. This is to ensure
                the safety and security of the member’s membership in the SACCO.
              </p>
            </div>
          </div>
          <div className="flex-1 overflow-y-auto px-5 pb-6 mt-5">
            {/* Inputs */}
            <div className="flex flex-col gap-5">
              <div className="flex flex-col">
                <label className="mb-1 text-md text-[#000]">Full name</label>
                <input
                  type="text"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="w-full bg-[#EAEAEA] border-[1px] border-[#EAEAEA] h-10 px-4 rounded"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-md text-[#000]">
                  Date of birth
                </label>
                <input
                  type="date"
                  value={dateOfBirth}
                  max={today}
                  onChange={(e) => setDateOfBirth(e.target.value)}
                  className="w-full bg-[#EAEAEA] border-[1px] border-[#EAEAEA] h-10 px-4 rounded"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-md text-[#000]">Relationship</label>
                <input
                  type="text"
                  value={relationship}
                  onChange={(e) => setRelationship(e.target.value)}
                  className="w-full h-10 px-4 rounded bg-[#EAEAEA] border-[1px] border-[#EAEAEA]"
                />
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-md text-[#000]">Phone number</label>
                <input
                  type="text"
                  value={mobileNumber}
                  onChange={handlePhoneChange}
                  className={`w-full h-10 px-4 rounded bg-[#EAEAEA] border-[1px] ${
                    phoneError ? "border-red-500" : "border-[#EAEAEA]"
                  }`}
                />
                {phoneError && (
                  <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                )}
              </div>

              <div className="flex flex-col">
                <label className="mb-1 text-md text-[#000]">Location</label>
                <input
                  type="text"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                  className="w-full h-10 px-4 rounded bg-[#EAEAEA] border-[1px] border-[#EAEAEA]"
                />
              </div>
            </div>
          </div>

          <div className="p-4">
            <button
              onClick={handleNextOfKin}
              disabled={!isInputsFilled || loading}
              className={`w-full text-white px-6 py-2 rounded flex items-center justify-center ${isInputsFilled ? "bg-[#074073]" : "bg-[#D9D9D9]"}  ${loading ? "opacity-60 cursor-not-allowed" : ""}`}
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                    ></path>
                  </svg>
                  Completing ...
                </div>
              ) : (
                "Complete"
              )}
            </button>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default NextofKinPanel;
